import {
  AfterViewInit,
  Component,
  ElementRef, EventEmitter, HostListener, OnInit,
  Output,
  ViewChild, ViewEncapsulation
} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {Constant} from '../../global/util/Constant';
import {StringUtil} from '../../global/util/StringUtil';
import {TranslateService} from '@ngx-translate/core';
import {LocalStorage} from '../../global/util/LocalStorage';
import {Dialog} from '../../global/util/Dialog';
import {InformType} from '../../global/util/enum/InformType';
import {PersonService} from '../../user/service/person.service';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UnitMeasure} from '../../global/util/UnitMeasure';
import {NgxImageCompressService} from 'ngx-image-compress';

@Component({
  selector: 'app-signature-pad',
  templateUrl: './signature-pad.component.html',
  styleUrls: ['./signature-pad.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class SignaturePadComponent implements OnInit {
  @Output() signatureSaved = new EventEmitter();
  @ViewChild('canvas', {static: true}) canvas: ElementRef<HTMLCanvasElement>;
  @Output() signatureChange: EventEmitter<string> = new EventEmitter<string>();

  private context: CanvasRenderingContext2D;
  private isDrawing = false;
  public isInvited: boolean;
  public personId?: number;
  public uuid?: string;
  private signatureImg?: string;
  private sigPadElement: any;
  public signaturePadForm: FormGroup;
  public lineWitdh = 5;
  public strokeColor = 'black';
  public rubricSrc: string | ArrayBuffer;
  public previewRubricWidth = '350';
  public isReady2Save = false;
  public isDrawComplete = false;
  public isDrawTabOption = false;

  constructor(private formBuilder: FormBuilder,
              private personService: PersonService,
              private activeModal: NgbActiveModal,
              private translate: TranslateService,
              private imageCompressService: NgxImageCompressService) {
    this.createForm();
  }

  public createForm() {
    this.signaturePadForm = this.formBuilder.group({
      lineWitdh: [''],
      strokeColor: [''],
      rubricFilename2Show: [''],
      rubricFileBase64: [''],
      rubricFilename: [''],
      extensionFilename: [''],
    });
  }

  ngOnInit() {
    this.context = this.canvas.nativeElement.getContext('2d');
    this.context.lineWidth = 2;
    this.context.lineCap = 'round';
    this.context.strokeStyle = '#000000';
    this.sigPadElement = this.canvas.nativeElement;

    // Eventos táctiles
    this.canvas.nativeElement.addEventListener('touchstart', (event) => this.startDrawing(event), false);
    this.canvas.nativeElement.addEventListener('touchmove', (event) => this.draw(event), false);
    this.canvas.nativeElement.addEventListener('touchend', () => this.stopDrawing(), false);
  }

/*  public ngAfterViewInit(): void {
    this.sigPadElement = this.signPad.nativeElement;
    this.context = this.sigPadElement.getContext('2d');
    this.context.strokeStyle = '#000';
  }*/

  get placeHoldItRubric(): string {
    return Constant.DEFAULT_IMAGE;
  }

  /**
   * Captura cuando el usuario comienza a dibujar su rubrica
   */
  onMouseDown(e: any): void {
    // The mouse button is clicked, which means the start of drawing the signature
    this.isDrawing = true;
    this.isDrawComplete = true;
    const coords = this.relativeCoords(e);
    this.context.moveTo(coords.x, coords.y);
  }

  /**
   * Acción que captura cuando el usuario suelta mouse o touchPad
   */
  @HostListener('document:mouseup', ['$event'])
  onMouseUp(): void {
    // The mouse button is released, so this means the end of drawing the signature
    this.isDrawing = false;
  }

  /**
   * Captura los movimiento de mouse o touch del usuario al momento de dibujar su rubrica
   */
  onMouseMove(e: any): void {
    if (this.isDrawing) { // if we're not drawing we need to ignore the events
      const coords = this.relativeCoords(e);
      this.context.lineTo(coords.x, coords.y);
      this.context.lineWidth = this.lineWitdh;
      this.context.lineJoin = 'round';
      this.context.strokeStyle = this.strokeColor;
      this.context.stroke();
    }
  }

  cancel(): void {
    this.activeModal.close(InformType.Anything);
  }

  /**
   * Limpia el dibujo de la rubrica
   */
  clearSignature(): void {
    this.isDrawComplete = false;
    this.signatureImg = undefined;
    this.context.clearRect(0, 0, this.sigPadElement.width, this.sigPadElement.height);
    this.context.beginPath();
  }

  /**
   * Guarda la imagen subica por usuario.
   */
  saveSignature(): void {
    if (this.isInvited) {
      this.signatureImg = this.sigPadElement.toDataURL('image/png');
      this.CompressUpdateRubricInvited();
    } else {
      this.compressUpdateRubric();
    }
  }

  /**
   * Guarda la imagen dibujada por el usuario.
   */
  saveDrawSignature(): void {
    this.signatureImg = this.sigPadElement.toDataURL('image/png');
    if (this.isInvited) {
      this.updateDrawRubricInvited();
    } else {
      this.updateDrawRubric();
    }
  }

  /**
   * Actualiza las coordenadas del dibujo de rubrica realizado por el cliente.
   * @param event
   * @private
   */
  private relativeCoords(event: any): { x: number, y: number } {
    const bounds = event.target.getBoundingClientRect();
    const cords = {
      clientX: event.clientX || event.changedTouches[0].clientX,
      clientY: event.clientY || event.changedTouches[0].clientY
    };
    const x = cords.clientX - bounds.left;
    const y = cords.clientY - bounds.top;
    return {x, y};
  }

  /**
   * Lee la imagen subida por el usuario y la muestra.
   * @param event
   */
  public readSelectedRubric(event: any): void {
    const testFile = event.target.files[0];
    if (testFile.name.endsWith('.png') || testFile.name.endsWith('.jpg') || testFile.name.endsWith('.jpeg')
      || testFile.name.endsWith('.PNG') || testFile.name.endsWith('.JPG') || testFile.name.endsWith('.JPEG')) {
      if (event.target.files && event.target.files[0]) {
        const file = event.target.files[0];
        const reader = new FileReader();
        reader.onload = () => this.rubricSrc = reader.result;
        reader.readAsDataURL(file);
      }
    }
  }

  public changeStatus(event: any) {
    const testFile = event[Constant.ZERO_INDEX];
    if (testFile.name.endsWith('.png') || testFile.name.endsWith('.jpg') || testFile.name.endsWith('.jpeg')
      || testFile.name.endsWith('.PNG') || testFile.name.endsWith('.JPG') || testFile.name.endsWith('.JPEG')) {
      this.signaturePadForm.patchValue({
        rubricFileBase64: testFile.base64,
        rubricFilename: testFile.name,
        extensionFilename: testFile.type.split('/').pop(),
        rubricFilename2Show: StringUtil.cut(testFile.name, 42, this.translate.instant('MESSAGE.SELECT')),
      });
      this.updateValueAndValidityRubricFields();
    } else {
      Dialog.show(InformType.Warning, this.translate.instant('TITLE.RUBRIC-UPDATE'), this.translate.instant('MESSAGE.SELECTED-NOT-ALLOWED-FILE'));
      return;
    }
  }

  private updateValueAndValidityRubricFields() {
    this.signaturePadForm.get('rubricFileBase64').updateValueAndValidity();
    this.signaturePadForm.get('rubricFilename').updateValueAndValidity();
    this.signaturePadForm.get('rubricFilename2Show').updateValueAndValidity();
    this.isReady2Save = true;
  }

  public isInvalidControl(ctrlName: string) {
    return this.signaturePadForm.get(ctrlName).invalid && this.signaturePadForm.get(ctrlName).touched;
  }

  get defaultRubricSrc(): string | ArrayBuffer {
    return this.rubricSrc || this.placeHoldItRubric;
  }

  get styleDimensionsRubric(): string {
    return 'width: ' + this.previewRubricWidth + 'px; height: 210px';
  }

  /**
   * Envia la imagen dibujada al servidor para ser guardada.
   */
  public updateDrawRubric(): void {
    const rubricFileBase64: string = this.signatureImg;
    const rubricFilename = 'drawImage.png';
    const url = Constant.ROOT_API_V1.concat('/people/', String(LocalStorage.getPersonId()), '/rubric');
    this.personService.updateRubric(url, rubricFileBase64, rubricFilename).subscribe(() => {
      Dialog.show(InformType.Success, this.translate.instant('TITLE.RUBRIC-UPDATE'));
      LocalStorage.setItem('rubricFile', this.signatureImg);
      this.activeModal.close(InformType.Success);
    }, () => {
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.RUBRIC-UPDATE'));
    });
  }

  /**
   * Envia la imagen dibujada al servidor para ser guardada.
   */
  public updateDrawRubricInvited(): void {
    const rubricFileBase64: string = this.signatureImg;
    const rubricFilename = 'drawImage.png';
    const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/rubric?uuid=', this.uuid);
    this.personService.updateRubric(url, rubricFileBase64, rubricFilename).subscribe(() => {
      Dialog.show(InformType.Success, this.translate.instant('TITLE.RUBRIC-UPDATE'));
      LocalStorage.setItem('rubricFile', this.signatureImg);
      this.activeModal.close(InformType.Success);
    }, () => {
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.RUBRIC-UPDATE'));
    });
  }

  /**
   * Vrificamos el tamaño de la imagen seleccionada, si es mayor a 1 MB se comprime la imagen reduciendo en peso en un 70%
   */
  public compressUpdateRubric(): void {
    const rubricFileBase64: string = this.signaturePadForm.get('rubricFileBase64').value;
    const rubricFilename: string = this.signaturePadForm.get('rubricFilename').value;
    const sizeOfOriginalImage = this.imageCompressService.byteCount(rubricFileBase64) / (1024 * 1024);
    if (sizeOfOriginalImage >= UnitMeasure.ONE_MB && rubricFileBase64 !== '') {
      // tslint:disable-next-line:one-variable-per-declaration
      const orientation = -1, radio = 40, quality = 40;
      this.imageCompressService.compressFile(rubricFileBase64, orientation, radio, quality).then(resultBase64Compress => {
        console.log('Size in bytes is now:', this.imageCompressService.byteCount(resultBase64Compress) / (1024 * 1024));
        this.updateRubric(resultBase64Compress, rubricFilename);
      });
    } else {
      this.updateRubric(rubricFileBase64, rubricFilename);
    }
  }

  /**
   * Vrificamos el tamaño de la imagen seleccionada, si es mayor a 1 MB se comprime la imagen reduciendo en peso en un 70%
   */
  public CompressUpdateRubricInvited(): void {
    const rubricFileBase64: string = this.signaturePadForm.get('rubricFileBase64').value;
    const rubricFilename: string = this.signaturePadForm.get('rubricFilename').value;
    const rubricFileExtension: string = this.signaturePadForm.get('extensionFilename').value;
    const sizeOfOriginalImage = this.imageCompressService.byteCount(rubricFileBase64) / (1024 * 1024);
    if (sizeOfOriginalImage >= UnitMeasure.ONE_MB && rubricFileBase64 !== '') {
      // tslint:disable-next-line:one-variable-per-declaration
      const orientation = -1, radio = 40, quality = 40;
      this.imageCompressService.compressFile(rubricFileBase64, orientation, radio, quality).then(resultBase64Compress => {
        this.updateRubricInvited(resultBase64Compress, rubricFilename, rubricFileExtension);
      });
    } else {
      this.updateRubricInvited(rubricFileBase64, rubricFilename, rubricFileExtension);
    }
  }

  change(signatureDrawing: boolean) {
    this.isDrawTabOption = signatureDrawing;
    return this.isDrawTabOption;
  }

  /**
   * Envia la imagen cargada al servidor para ser guardada.
   * @param resultBase64Compress
   * @param rubricFilename
   * @private
   */
  private updateRubric(resultBase64Compress: string, rubricFilename: string) {
    const url = Constant.ROOT_API_V1.concat('/people/', String(LocalStorage.getPersonId()), '/rubric');
    this.personService.updateRubric(url, resultBase64Compress, rubricFilename).subscribe(() => {
      Dialog.show(InformType.Success, this.translate.instant('TITLE.RUBRIC-UPDATE'));
      LocalStorage.setItem('rubricFile', this.rubricSrc);
      this.activeModal.close(InformType.Success);
    }, () => {
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.RUBRIC-UPDATE'));
    });
  }

  /**
   * Envia la imagen cargada al servidor para ser guardada.
   * @param rubricFileBase64
   * @param rubricFilename
   * @param rubricFileExtension
   * @private
   */
  private updateRubricInvited(rubricFileBase64: string, rubricFilename: string, rubricFileExtension: string) {
    const url = Constant.ROOT_API_V1.concat('/public/people/', String(this.personId), '/rubric?uuid=', this.uuid);
    this.personService.updateRubric(url, rubricFileBase64, rubricFilename).subscribe(() => {
      Dialog.show(InformType.Success, this.translate.instant('TITLE.RUBRIC-UPDATE'));
      LocalStorage.setItem('rubricFileExtension', rubricFileExtension);
      LocalStorage.setItem('base64RubricFile', rubricFileBase64);
      LocalStorage.setItem('rubricFile', this.rubricSrc);
      this.activeModal.close(InformType.Success);
    }, () => {
      Dialog.show(InformType.Danger, this.translate.instant('TITLE.RUBRIC-UPDATE'));
    });
  }


  startDrawing(event: MouseEvent | TouchEvent) {
    event.preventDefault();
    const coordinates = this.getCoordinates(event);
    this.isDrawing = true;
    this.isDrawComplete = true;
    this.context.lineWidth = this.lineWitdh;
    this.context.strokeStyle = this.strokeColor;
    this.context.stroke();
    this.context.beginPath();
    this.context.moveTo(coordinates.x, coordinates.y);
  }

  draw(event: MouseEvent | TouchEvent) {
    event.preventDefault();
    if (!this.isDrawing) {
      return;
    }

    const coordinates = this.getCoordinates(event);
    this.context.lineTo(coordinates.x, coordinates.y);
    this.context.stroke();
  }

  stopDrawing() {
    this.isDrawing = false;
    this.emitSignature();
  }

  private emitSignature() {
    const signatureDataUrl = this.canvas.nativeElement.toDataURL();
    this.signatureChange.emit(signatureDataUrl);
  }

  private getCoordinates(event: MouseEvent | TouchEvent) {
    const rect = this.canvas.nativeElement.getBoundingClientRect();
    // tslint:disable-next-line:one-variable-per-declaration
    let x, y;

    if (event instanceof MouseEvent) {
      x = event.clientX - rect.left;
      y = event.clientY - rect.top;
    } else if (event instanceof TouchEvent) {
      x = event.touches[0].clientX - rect.left;
      y = event.touches[0].clientY - rect.top;
    }

    return {x, y};
  }

}



